import { Box, Divider, Typography } from '@mui/material'
import { MusicTheory, ScaleSelect } from '@tunasong/music-ui'
import type { Scale } from '@tunasong/schemas'
import { useState } from 'react'

export const MusicTheoryPage = () => {
  const [scale, setScale] = useState<Scale | null>({ root: 'C', type: 'major' })

  return (
    <Box sx={{ p: 4, overflow: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Select a Scale
      </Typography>
      <ScaleSelect value={scale} onChange={setScale} allowNone={false} />
      <Divider sx={{ my: 2 }} />
      {scale && <MusicTheory scale={scale} />}
    </Box>
  )
}

export default MusicTheory
